export const feedbackConstants = {
  CLEAR_STATE: 'CLEAR_STATE',
  CREATE_FEEDBACK_REQUEST: 'CREATE_FEEDBACK_REQUEST',
  CREATE_FEEDBACK_SUCCESS: 'CREATE_FEEDBACK_SUCCESS',
  CREATE_FEEDBACK_FAILURE: 'CREATE_FEEDBACK_FAILURE'
};
